export class PlaceDetail{
    IS_MARKED:boolean;
    PLACE:any;
    WEBSITE: string;
    NUMBER:string;
    RATING:number;
    SHOW_EXTRA_DETAIL:boolean;
    SHOW_DETAIL_LOADING:boolean;
    IS_EXTRA_DETAILS_GET:boolean;
    IMAGE: string;
    MARKER_NUMBER: number;

    // Helper
    COPIED: boolean = false;

    constructor(){
      this.IS_MARKED = false;
      this.PLACE = {};
      this.WEBSITE = '';
      this.NUMBER = '';
      this.RATING = -1;
      this.SHOW_EXTRA_DETAIL = false;
      this.SHOW_DETAIL_LOADING = false;
      this.IS_EXTRA_DETAILS_GET = false;
      this.IMAGE = '';

      this.COPIED = false;
    }
}
